import React from "react";
import './Team.css';
import bourbonbelly  from '../../assets/img/team/bourbonbelly.png';
import buddyg  from '../../assets/img/team/buddyg.png';
import dunderdata  from '../../assets/img/team/dunderdata.png';
import jamie  from '../../assets/img/team/jamie.jpg';
import mcshizzy  from '../../assets/img/team/mcshizzy.png';
import nachodad  from '../../assets/img/team/nachodad.png';
import nico  from '../../assets/img/team/nico.png';
import nikpreston  from '../../assets/img/team/nikpreston.png';
import phunster  from '../../assets/img/team/phunster.png';
import linkedinLogo  from '../../assets/icons/linkedin-logo-initials.png';
import instagramLogo  from '../../assets/icons/instagram-logo.png';
import twitterLogo  from '../../assets/icons/twitter-logo.svg';
import { AnimationOnScroll } from 'react-animation-on-scroll';

export default class Team extends React.Component {

	renderPortrait(portrait){

		const renderLink = (link) =>{
			if (link === ""  || link ==null) return <div className="no-link-filler"></div>

			let logo = null;
			if (link.includes('instagram.com')) logo = instagramLogo;
			if (link.includes('twitter.com')) logo = twitterLogo;
			if (link.includes('linkedin.com')) logo = linkedinLogo;

			return <img src={logo} alt={portrait.name+" linkedin"} />
		}

		return <AnimationOnScroll initiallyVisible={false} animateIn="fadeInAnimation" animateOnce={true} delay={0}>
			<div className="team-portrait" key={portrait.pic}>
				<div className="picutre-container">
					<img src={portrait.pic} alt="" />
				</div>
				<div className="linkedin-container">

					<a href={portrait.link} target="_blank" rel="noreferrer">
						{renderLink(portrait.link)}

					</a>
				</div>
				<p className="section-title portrait-name">{portrait.name}</p>
				<p className="item-body">{portrait.position}</p>

			</div>
		</AnimationOnScroll>
	}

	render() {
		let portraits = [
			{pic:phunster, name:"PHU NGO", position:"Cofounder, Product and Tech", link:"https://www.linkedin.com/in/phungo"},
			{pic:bourbonbelly, name:"JOHN NGUYEN", position:"Cofounder, Tech", link:"https://www.linkedin.com/in/john-nguyen-82215a5/"},
			{pic:mcshizzy, name:"MATT SHIH", position:"Cofounder, Creative and Growth", link:"https://www.linkedin.com/in/mattshih/"},
			{pic:nico, name:"NICO PANFILI", position:"Senior Dev", link:"https://www.linkedin.com/in/nicolas-panfili-73129a5b/"},
			{pic:buddyg, name:"GARY WILSON", position:"Senior Dev", link:"https://www.linkedin.com/in/garywilsonjr"},
			{pic:dunderdata, name:"TEDDY PETROU", position:"Senior Data Scientist", link:"https://www.linkedin.com/in/tedpetrou"},
			{pic:jamie, name:"SAPHIREMOON", position:"Illustration Ninja", link:""},
			{pic:nikpreston, name:"PRESSEDON", position:"Digital Artist Ninja", link:"https://www.instagram.com/pressed0n/"},
			{pic:nachodad, name:"THEFULLNACHO", position:"Community and Marketing Lead", link:"https://twitter.com/thefullnacho"}
		]
		return (
		<div id="team" className="team-container">
			<AnimationOnScroll initiallyVisible={false} animateIn="fadeDown" animateOnce={true} delay={0}>
				<div className="section-briefing">
					<h1 className="section-title">TEAM</h1>
					<div className="briefing-text">
					</div>
				</div>
			</AnimationOnScroll>
			<AnimationOnScroll initiallyVisible={false} animateIn="fadeUp" animateOnce={true} delay={0}>
				<div className="section-showcase brown-gradient">
					<div className="portrait-list">
						{portraits.map(p=> this.renderPortrait(p))}
					</div>
				</div>
			</AnimationOnScroll>
		</div>
		);
	}
}
